export default "__VITE_ASSET__HiuwYG9v__"